module.exports = __webpack_public_path__ + "static/media/customer-danbro.1aebd4d8.png";